<script>
import axios from 'axios';
import {dataDictionary, listCommon} from "@/api/consult";


export default {
  name: 'ConsultDiolog',
  data() {
    return {
      n: 0,
      sendMsg: '',
      scrollTop: 0,
      Tips: ['请介绍一下创新创业领域', '创易通是什么？'],
      // AI回复的消息 { type:1, msg:"" }
      // 用户发送的消息 { type:0, msg:"" }
      msgList: [],
      curIndex: 0,
      chunkmsg: '',
      helpList: [],
      problemList: [],
      historyId: '',
      historyList: [],
      loading: false, // 加载中
      running: false, // 回答中
      loadMsg: [
        {text: '正在分析内容', time: 2000},
        {text: '搜索创业创新知识图谱', time: 8000},
        {text: '查询实体节点', time: 4000},
        {text: '查询节点关系', time: 6000},
        {text: '正在整理答案', time: 6000}
      ],
      loadTxt: '响应中',
      fill: '.',
      firmInfo: void 0,
      path: 'https://www.jnsme.cn/wechat-py', // 正式版 https://www.jnsme.cn/wechat-py
      bottomVal: 0, // 输入框高度
      timer: null //定时器
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 初始化消息
    async loadData() {
      // this.msgList.length = 0
      var params = {
        user_id: this.$store.state.auth.userInfo.userId,
        history_id: this.historyId,
        tenant_id: this.$store.state.auth.userInfo.tenantId,
      }
      if(params.history_id === ''){
        delete params.history_id
      }
      const response = await this.request('/microConsult/selectmsg', params, 'get')

      for (let i = 0; i < response.length; i++) {

        // 将转义换行更改为换行
        response.at(i).message = response.at(i).message.replace(/\\n/g, '\n');
      }
      await this.getDataDictionary()
      // 做临时问题类型数据
      response.push({
        type: 1,
        helpType: true,
        title: '常见分类',
        message: "您可能关心的问题分类 :",
        list: this.helpList
      })
      // 更新数据
      this.msgList = response
      this.historyList = await this.request('/microConsult/historyId', {
        user_id: this.$store.state.auth.userInfo.userId,
        tenant_id: this.$store.state.auth.userInfo.tenantId,
      }, 'Get')
      this.scrollToBottom()
    },
    // 获取问题类型
    async getDataDictionary() {
      return dataDictionary('w_helpType').then(res => this.helpList = res.data)
    },
    // 帮助
    help(item) {
      if (item.dictLabel) {
        // 用户添加回复
        this.msgList.push({
          type: 0,
          helpType: true,
          message: item.dictLabel
        })
        this.scrollToBottom()
        listCommon({theType: item.dictValue, isOnline: 1}).then(res => {
          if (res.data.length > 0) {
            // 保存完整的问题列表到problemList
            this.problemList = [...res.data];
            // 创建新数组进行随机选择，不影响problemList
            const randomList = res.data.length > 5
                ? [...res.data].sort(() => 0.5 - Math.random()).slice(0, 5)
                : [...res.data];

            this.msgList.push({
              type: 1,
              helpType: true,
              change: true,
              title: item.dictLabel,
              message: "以下是您可能关心的问题 :",
              list: randomList
            })
            this.scrollToBottom()
          } else {
            setTimeout(() => {
              this.msgList.push({
                type: 1,
                helpType: false,
                message: "暂无相关问题"
              })
              this.scrollToBottom()
            }, 1000)
          }
        })
      } else {
        // 用户回复
        this.msgList.push({
          type: 0,
          helpType: false,
          message: item.title
        })
        // 模拟AI回答
        setTimeout(() => {
          this.msgList.push({
            type: 1,
            helpType: false,
            message: item.answer
          })
          this.scrollToBottom()
        }, 1000)
      }

    },
    consultService() {
      this.$emit('consultService')
    },
    problemChange() {
      // 创建新数组进行随机选择，不影响problemList
      const randomList = this.problemList.length > 5
          ? [...this.problemList].sort(() => 0.5 - Math.random()).slice(0, 5)
          : [...this.problemList];
      this.msgList.push({
        type: 1,
        helpType: true,
        change: true,
        title: this.msgList[this.msgList.length - 1].title,
        message: "以下是您可能关心的问题 :",
        list: randomList
      })
      this.scrollToBottom()
    },
    handleEnter(e) {
      // 检查是否按下了shift键
      if (e.shiftKey) {
        // 允许默认换行行为
        return;
      }
      // 否则阻止默认行为并发送消息
      e.preventDefault();
      this.onSend();
    },
    historyDelete(history_id) {
      this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj = {
          user_id: this.$store.state.auth.userInfo.userId,
          tenant_id: this.$store.state.auth.userInfo.tenantId,
          history_id,
        }
        if (this.historyId === history_id) {
          this.msgList.length = 0
        }
        this.request('/microConsult/deletehistory', obj, 'Get').then(() => {
          if (history_id === this.historyId) {
            this.historyId = ''
            this.msgList.length = 0
            this.loadData()
          } else {
            this.request('/microConsult/historyId', {
              user_id: this.$store.state.auth.userInfo.userId,
              tenant_id: this.$store.state.auth.userInfo.tenantId,
            }, 'Get').then(res => {
              this.historyList = res
            })
          }
        })
        this.$message({
          type: 'success',
          message: '删除记录成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    onSend() {
      if (this.loading || this.running) {
        alert('模型响应中，请稍等')
        return
      }

      // 去除表情符号
      const cleanMsg = this.sendMsg.replace(/[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}]/gu, '')

      // 检查是否空
      if (cleanMsg.trim()) {
        let msg = {
          type: 0,
          message: cleanMsg
        }
        this.msgList.push(msg)

        // 发送数据
        this.fetchData(cleanMsg)

        this.sendMsg = ''
        this.scrollToBottom()
      } else {
        this.$modal.showToast('消息不能为空')
      }
    },
    // 从后端获取数据
    async fetchData(tip) {
      this.n = 0
      // 开始加载
      this.loading = true
      this.updateLoadTxt()

      try {
        var params = {
          // 查询内容
          query_content: tip,

          chat_items: {
            // 创建人id
            user_id: this.$store.state.auth.userInfo.userId,

            // 创建人姓名
            user_name: this.$store.state.auth.userInfo.userName,

            // 租户id
            tenant_id: this.$store.state.auth.userInfo.tenantId,

            // 历史记录id
            history_id: this.historyId,

            // 创建时间
            create_time: this.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
          }
        }
        if (this.historyId === '') {
          delete params.chat_items.history_id
        }
        //const response = await this.request('/query', params, 'POST')
        let msg = {
          type: 1,
          message: ''
        }
        this.msgList.push(msg)
        // 流式输出
        this.request_stream('/microConsult/querystream', params, 'POST')
        // 如果是新创建的  则没有历史id  重新调用历史id接口  并且回显数据
        setTimeout(() => {
          if (this.historyId === '') {
            this.request('/microConsult/historyId', {
              user_id: this.$store.state.auth.userInfo.userId,
              tenant_id: this.$store.state.auth.userInfo.tenantId,
            }, 'Get').then(res => {
              this.historyId = res[0].history_id
              this.historyList = res
            })
          }
        }, 500)
      } catch (error) {
        console.error(error)
      }
    },
    // 更新加载提示文字
    updateLoadTxt() {
      let startTime = 0 // 用于累积时间

      for (let item of this.loadMsg) {
        setTimeout(() => {
          this.loadTxt = item['text']
        }, startTime + item['time'])

        startTime += item.time // 更新累积时间
      }
    },
    // 填充字符串
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    // 格式化日期
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    async request_stream(url, params = {}) {
      const controller = new AbortController();
      this.controller = controller;

      // 清除旧定时器，设置新的超时控制
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        controller.abort();
        console.warn('请求超时，自动中止');
      }, 30 * 60 * 1000); // 30分钟

      this.running = true;
      this.loading = true;

      try {
        const response = await fetch(this.path + url, {
          method: 'POST', // 你也可以根据需要传入 GET
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(params),
          signal: controller.signal
        });

        if (!response.ok || !response.body) {
          throw new Error('请求失败或无可读流');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');

        // 初始化 message
        if (!this.msgList.length || typeof this.msgList[this.msgList.length - 1]?.message !== 'string') {
          this.msgList.push({message: ''});
        }

        let buffer = '';

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const {done, value} = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value, {stream: true});
          // eslint-disable-next-line no-unused-vars
          buffer += chunk;

          // 持续追加内容
          this.msgList[this.msgList.length - 1].message += chunk;
          this.scrollToBottom();
          this.loading = false;
        }

      } catch (err) {
        if (err.name === 'AbortError') {
          console.warn('请求被中止');
        } else {
          console.error('请求失败:', err);
        }
      } finally {
        this.running = false;
        this.loading = false;
        clearTimeout(this.timer);
      }
    },
    // 向大模型发消息
    request(url, params, method) {
      const config = {
        url: this.path + url,
        method: method,
        params,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      // // 根据请求方法设置参数位置
      // if (method === 'get') {
      //   config.params = params
      // } else {
      //   config.data = params
      // }
      return axios(config)
          .then(res => res.data)
          .catch(err => {
            throw new Error(`Request failed: ${err.response?.status || err.message}`)
          })
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    // 历史记录
    historyQuery(historyId) {
      this.historyId = historyId
      this.loadData()
    },
    // 新建
    addTalk() {
      // 1. 终止正在进行的流式请求
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }

      // 2. 重置状态
      this.historyId = ''
      this.loading = false
      this.running = false


      this.loadData()
    },
    close() {
      this.$emit('dialogClose', false)
    },
    minimize() {
      this.$emit('minimize')
    },
    maximize() {
      this.$emit('maximize')
    }
  }
}
</script>

<template>
  <div class="ConsultDiolog">
    <div class="left">
      <div class="top">济南市中小企业公共服务中心</div>
      <div class="bottom">
        <div class="record-title">
          <img src="@/assets/images/consult/dialogue.png" width="20" height="20">
          最近对话
        </div>
        <div class="record-list">
          <div :class="{'active' : historyId === item.history_id}" v-for="item in historyList" :key="item.history_id"
               @click="historyQuery(item.history_id)">
            <p>{{ item.content }}</p>
            <i class="el-icon-delete" @click.stop="historyDelete(item.history_id)"/>
          </div>
        </div>
        <div class="dialogueAdd" @click="addTalk">
          <img src="@/assets/images/consult/dialogueAdd.png" width="20" height="20">
          开启新对话
        </div>
      </div>

    </div>
    <div class="right">
      <div class="top">
        <div class="text">
          <!--          <img style="vertical-align: middle;" src="@/assets/images/AI_logo.png" width="40" height="40">-->
          <div>微咨询助手</div>
          <div>专为微咨询场景打造的人工智能引擎,用心服务您的每一次咨询</div>
        </div>
        <div class="bts">
          <div @click="consultService">
            <img src="@/assets/images/expert.png" width="20" height="20">
            人工服务
          </div>
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>
      <div class="bottom">
        <div class="content_msg" ref="chatContainer">
          <div class="add" v-if="msgList.length < 3">
            <img src="@/assets/images/AIlogo.png" width="50" height="50">
            <div>
              <p>您好，我是微咨询大模型，随时为您答疑解惑~</p>
              <p>您可以尝试选择以下问题分类/进行提问，帮助您更好的解决问题</p>
            </div>
          </div>
          <div class="" v-for="(item, index) in msgList" :key="index" style="display: flex">
            <!--tpye为0 由用户发送
              type为1 由AI发送-->
            <div user-select v-if="item.type == 0" class="msg person">{{ item.message }}</div>
            <img v-if="item.type == 1" src="https://www.chuangyitong.cn/app_statics/mine/zhushou.png"
                 style="margin-right: 10px;margin-top: -3px" width="40" height="40"/>
            <div user-select v-if="item.type == 1" class="msg robot">

              {{ item.message }}
              <!--              临时问题分类渲染-->
              <div v-if="item.helpType" class="help">
                <span class="help-title">{{ item.title }}</span>
                <!--              <el-divider></el-divider>-->
                <div class="help-list">
                <span :class="im.dictLabel ? 'item' : 'problem'" v-for="(im,ix) in item.list" :key="ix"
                      @click="help(im)">
                  ✦&nbsp;{{ im.dictLabel ? (im.dictLabel || '暂无数据') : (im.title || '暂无数据') }}
                </span>
                </div>
                <!--              <el-divider></el-divider>-->
                <div v-if="item.change" class="change" @click="problemChange">
                  换一批
                </div>
              </div>
            </div>
          </div>
          <div class="fill">
            <div v-if="loading" class="loading">{{ fill }}</div>
          </div>
        </div>
        <div class="send-input">
          <el-input type="textarea" @keydown.enter.native="handleEnter" v-model="sendMsg"
                    placeholder="请输入  回车键发送 , 如若换行请用  shift + enter" :rows="5"/>
          <div class="img-bg" @click="onSend">
            <img src="@/assets/images/send.png" width="20" height="20">
          </div>
        </div>
        <div class="prompt-text">
          服务生成的所有内容均由人工智能模型生成,其生成内容的准确性和完整性无法保证,不代表我们的态度或观点
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ConsultDiolog {
  width: 1150px;
  height: 700px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.42),
  0 0 15px rgba(154, 210, 255, 0.56);
  display: flex;

  .left {
    width: 250px;
    height: 100%;
    background: #fff;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    .top {
      line-height: 60px;
      background: #0E76FF;
      border-top-left-radius: 20px;
      //border-top-right-radius: 20px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      font-weight: bold;
      font-size: 16px;
    }

    .bottom {
      height: calc(100% - 60px);
      border-bottom-left-radius: 20px;

      .record-title {
        display: flex;
        align-items: center;
        margin: 10px 0 10px 20px;

        img {
          margin-right: 7px;
        }
      }

      .dialogueAdd {
        padding: 10px;
        background: #D5E7FF;
        color: #0E76FE;
        margin: 10px 20px 20px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          margin-right: 5px;
        }

        border-radius: 12px;
      }

      .record-list {
        height: calc(100% - 100px);
        overflow: auto;
        padding: 5px 20px 20px 20px;

        div {

          font-size: 16px;
          //margin-bottom: 15px;
          cursor: pointer;
          padding: 10px;
          border-radius: 12px;
          display: flex;

          p {
            margin: 0;
            width: 90%;
            // 超过一行省略
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .el-icon-delete {
            position: relative;
            z-index: 2;
            opacity: 0;
          }

          &:hover {
            background: #D5E7FF;
            color: #0E76FE;
            transition: all 0.3s;

            .el-icon-delete {
              opacity: 1;
              transition: all 0.3s;
            }
          }
        }

        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        /* 滚动条轨道 */
        &::-webkit-scrollbar-track {
          background: rgba(234, 242, 253, 0.5);
          border-radius: 3px;
        }

        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          background: rgba(14, 118, 254, 0.3);
          border-radius: 3px;
          transition: all 0.3s;

          &:hover {
            background: rgba(14, 118, 254, 0.5);
          }
        }
      }
    }

  }

  .right {
    width: 900px;
    height: 100%;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;

    .top {
      height: 60px;
      background: #fff;
      border-top-right-radius: 20px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;

      .bts {
        display: flex;

        div {
          width: 110px;
          height: 34px;
          border-radius: 40px;
          background: #E1EEFF;
          box-sizing: border-box;
          //border: 1px solid #006EFF;
          color: #1b7bfa;
          font-family: 'AlibabaPuHuiTi';
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 13px 20px 0 0;
          cursor: pointer;
        }

        .el-icon-close {
          font-size: 22px;
          color: #78889E;
          margin-top: 20px;
          cursor: pointer;
        }
      }

      .text {
        padding-top: 10px;
        display: flex;

        div:nth-of-type(1) {
          font-size: 20px;
          color: #3D3D3D;
          font-weight: bold;
          font-family: 'AlibabaPuHuiTi';
          margin-left: 15px;
          padding-top: 9px;
        }

        div:nth-of-type(2) {
          font-size: 18px;
          margin-left: 12px;
          font-family: 'DingTalk';
          color: #4D6498;
          padding-top: 13px;
        }
      }
    }

    .bottom {
      padding: 17.5px;
      background: #eaf2fd;
      border-bottom-right-radius: 20px;
      height: calc(100% - 60px);
      //border-bottom-left-radius: 20px;
      //border-bottom-right-radius: 20px;
    }
  }
}

.content_msg {
  height: 450px;
  overflow: auto;
  //margin-top: 80rpx;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  /* 滚动条整体样式 */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  /* 滚动条轨道 */
  &::-webkit-scrollbar-track {
    background: rgba(234, 242, 253, 0.5);
    border-radius: 3px;
  }

  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    background: rgba(14, 118, 254, 0.3);
    border-radius: 3px;
    transition: all 0.3s;

    &:hover {
      background: rgba(14, 118, 254, 0.5);
    }
  }

  .msg {
    padding: 14px;
    margin-bottom: 24px;
    max-width: 590px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    display: inline-block;

    line-height: 1.5;
    font-family: AlibabaPuHuiTi;
    font-size: 14px;
    font-weight: normal;
  }

  .person {
    margin-left: auto;
    color: #ffffff;
    background-color: #6bafff;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
  }

  .robot {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
  }

  @keyframes progressbar {
    0% {
      background-position: 100rpx 0;
    }
    100% {
      background-position: 0 0;
    }
  }

  .loading {
    color: white;
    height: 100px;
    width: 100px;
    align-self: center;
    background-image: url(https://lckczx.oss.cn-north-3.inspurcloudoss.com/AI/cyt-chat/image/loading.gif);
    background-size: 100%;
    background-position: center;
    // animation: progressbar 1s linear infinite;
  }

  .load_text {
    align-self: center;
    font-family: AlibabaPuHuiTi;
    font-size: 10px;
    font-weight: normal;
  }
}

.send-input {
  margin-top: 17px;
  position: relative;

  .img-bg {
    position: absolute;
    right: 5px;
    bottom: 5px;
    background: #0E76FE;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    cursor: pointer;
  }

  ::v-deep .el-textarea__inner {
    border: none;
    border-radius: 10px;
    resize: none !important; // 去除右下角图标


  }
}

.help {
  border-top: 1px dashed #dcddde;
  margin-top: 5px;
  padding-top: 5px;
  width: 430px;

  .help-list {
    display: flex;
    flex-wrap: wrap;

    .item, .problem {
      border-radius: 4px;
      padding: 6px;
      text-align: center;
      box-sizing: border-box;
      width: 120px;
      color: #0d7aff;
      margin-right: 20px;
      margin-top: 10px;
      cursor: pointer;
    }

    .problem {
      width: 100%;
      text-align: left;
    }
  }

  .help-title {
    font-size: 16px;
    font-weight: bold;
    color: #848f9e;
    margin-left: 5px;
  }

  .change {
    text-align: center;
    color: #0d7aff;
    border-top: 1px dashed #dcddde;
    padding-top: 5px;
    cursor: pointer;
  }
}

.fill {
  display: flex;
  justify-content: center;
  align-items: center;
}

.active {
  background: #E7F4FF;
  color: rgb(98, 127, 195);
}

.add {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 117px;
  margin-bottom: 20px;

  div {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-left: 10px;
  }

  p:nth-of-type(1) {
    font-family: 'AlibabaPuHuiTi55';
    font-size: 26px;
    margin: 0;
    margin-bottom: 10px;
  }

  p:nth-of-type(2) {
    font-family: 'AlibabaPuHuiTi55';
    font-size: 18px;
    margin: 0;
  }
}

.prompt-text {
  color: rgb(111, 111, 114);
  text-align: center;
  margin-top: 10px;
}
</style>
